import React, { useEffect, useState } from 'react';
import { BoKNavigation } from 'lib/templates/Feature.BOKF.model';
import { useRouter } from 'next/router';

import WidgetWrapper from 'helpers/WidgetWrapper/WidgetWrapper';
import EnhancedSearchLandingWidget from 'widgets/EnhancedSearchLandingWidget/EnhancedSearchLandingWidget';

type EnhancedSearchLandingProps = BoKNavigation.SiteSearch;

const EnhancedSearchLanding = (props: EnhancedSearchLandingProps) => {
  const router = useRouter();
  const { SearchBarPlaceholderText, SearchFormTarget } = props.fields || {};

  const [currentPageURL, setCurrentPageURL] = useState('');

  useEffect(() => {
    // Set currentPageURL only on the client side
    if (typeof window !== 'undefined') {
      setCurrentPageURL(`${window.location.origin}${router.asPath}`);
    }
  }, [router.asPath]);
  return (
    <WidgetWrapper>
      <EnhancedSearchLandingWidget
        rfkId={'rfkid_7'}
        searchBarPlaceholderText={SearchBarPlaceholderText?.value}
        searchFormTarget={currentPageURL}
        searchPageUrl={SearchFormTarget?.value?.href}
      />
    </WidgetWrapper>
  );
};
export default EnhancedSearchLanding;
